export function shortenAddress(
  address?: string,
  startChars = 6,
  endChars = 6,
  separator = '...',
): string {
  if (!address) return '';

  if (address.length <= startChars + endChars + separator.length) {
    return address;
  }

  return `${address.slice(0, startChars)}${separator}${address.slice(-endChars)}`;
}